module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('main', [_vm._l((_vm.players), function(player, index) {
    return _c("setup-player", {
      tag: "div",
      attrs: {
        "player": player
      },
      on: {
        "removePlayer": function($event) {
          _vm.players.splice(index, 1)
        }
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "add",
    on: {
      "click": _vm.addPlayer
    }
  }, [_vm._v("Add a player")]), _vm._v(" "), _c('button', {
    staticClass: "start",
    attrs: {
      "disabled": !_vm.canStart
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Start")])], true)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', [_c('span', [_vm._v("Dutch Blitz Scorekeeper")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0489c196!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 89
// module chunks = 2